<div class="question-title asterisk">
    <svg-icon *ngIf="question?.requierd" svgClass="svg-img-mini img" src="/assets/images/question-menu/asterisk.svg"></svg-icon>
    <img class="image-type" *ngIf="!isPreview" src="/assets/images/types/{{question.type.image}}" />
    <p *ngIf="question.title else placeholder" [style]="{'color': color$ | async}">{{question.title}}</p>
</div>

<ng-template #placeholder>
    <p *ngIf="!isPreview " queDisplayByType [name]="'inputTitle'" [typeId]="question.type.id"
        [style]="{'color': color$ | async}" translate>questionBoard.edit.TitleCome</p>
    <p *ngIf="!isPreview " queDisplayByType [name]="'inputTitleToImage'" [typeId]="question.type.id"
        [style]="{'color': color$ | async}" translate>questionBoard.edit.questionComeImage</p>
</ng-template>

